var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-google-tag-manager"},[(_vm.type === 'left')?_c('div',{attrs:{"id":"div-gpt-ad-1621131-2"}}):(_vm.type === 'right')?_c('div',{attrs:{"id":"div-gpt-ad-1621131-3"}}):_c('div',{attrs:{"id":"div-gpt-ad-1621131-5"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae06e98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customized-core/GoogleTagManager.vue
// module id = 5/1f
// module chunks = 1